module.exports = __webpack_public_path__ + "static/media/9.639d827f.jpg";